export { default } from './InfoCount';
